export default {
	formatValue: (value: string) => {
		return value?.toUpperCase();
	}
};
